import { Button as UIButton } from "@mui/material";
import Edit2LineIcon from "remixicon-react/Edit2LineIcon";
import JTooltip from "$components/JTooltip/JTooltip";
import { useStyles } from "../styles";

type EditButtonProps = {
  onClick: () => void;
  canEdit: boolean;
  isFullyDisabled: boolean;
};

export default function EditButton({
  onClick,
  canEdit,
  isFullyDisabled,
}: EditButtonProps) {
  const classes = useStyles();

  return (
    <JTooltip
      title={
        isFullyDisabled
          ? canEdit
            ? "Vous ne pouvez pas éditer un chantier inactif."
            : "Vous n'avez pas les droits pour éditer ce chantier."
          : ""
      }
    >
      <UIButton
        className={classes.editButton}
        disabled={isFullyDisabled}
        onClick={onClick}
      >
        <Edit2LineIcon />
      </UIButton>
    </JTooltip>
  );
}
